// core
import React, { useState } from "react";
import { Modal, BackdropProps } from "@material-ui/core";

// components
import Loader from "../../Loader/Loader";

// hooks
import useWindowDimensions from "../../../hooks/useWindowDimensions";

// styles
import cx from "classnames";
import styles from "./LModal.module.scss";
import { BlurPage } from "../PageBlurProvider";
import { DimPage } from "../PageDimProvider";

export interface IModal {
    isOpen: boolean;
    isLoading?: boolean;
    width?: "narrow" | "normal" | "wide" | "ultra-wide";
    calcHeightMode: "setHeightManual" | "auto";
    backgroundDimStyle?: "dim" | "blur" | "none";
    Header: () => React.ReactNode;
    children: (setHeight: (number: number) => void) => React.ReactNode;
    onClose?: () => void;
    removePadding?: boolean;
    isCentered?: boolean;
}

const Backdrop: React.FC<BackdropProps> = (props) => {
    return props.open ? (
        <div aria-hidden="true" className={styles["legacy-modal--backdrop"]}></div>
    ) : null;
};

const LModal: React.FC<IModal> = (props) => {
    const [heightContent, setHeight] = useState(0);
    const { height } = useWindowDimensions();
    const pageHeight = height || 0;
    const classes = cx([
        styles["legacy-modal"],
        {
            [styles["legacy-modal--narrow"]]: props.width == "narrow",
            [styles["legacy-modal--wide"]]: props.width == "wide",
            [styles["legacy-modal--ultra-wide"]]: props.width == "ultra-wide"
        }
    ]);
    // Default to Dim
    const backgroundDimStyle = props.backgroundDimStyle || "dim";

    const finalHeight =
        props.calcHeightMode === "setHeightManual"
            ? (heightContent === 0 ? pageHeight - 80 : heightContent) + "px"
            : "auto";

    return (
        <Modal
            BackdropComponent={Backdrop}
            disableEnforceFocus
            onEscapeKeyDown={() => props.onClose && props.onClose()}
            open={!!props?.isOpen}
            onClose={() => {
                props.onClose && props.onClose();
            }}
            data-backdrop="true"
            onClick={(e) => {
                // we need this for scrolling to work
                const target = e.target as HTMLDivElement;

                if (target?.dataset?.backdrop === "true") {
                    props.onClose && props.onClose();
                }
            }}
            className={cx(styles["legacy-modal--wrapper"], {
                [styles["centered"]]: props.isCentered
            })}>
            <div className={classes}>
                <div className={styles["legacy-modal--content"]}>
                    {props.Header && props.Header()}
                    <div
                        className={cx("text-font-size-m", {
                            [styles["modal-content-padding"]]:
                                !props.isLoading && !props.removePadding
                        })}
                        style={{
                            height: props.isLoading ? 250 : finalHeight
                        }}>
                        {props.isLoading ? (
                            <Loader icon="Default" />
                        ) : (
                            props.children(setHeight)
                        )}
                    </div>
                    {backgroundDimStyle === "dim" && <DimPage />}
                    {backgroundDimStyle === "blur" && <BlurPage />}
                </div>
            </div>
        </Modal>
    );
};

export default LModal;
